import React from 'react';

import type { IIcon } from '../types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 30, className, onClick }, ref) {
  return (
    <svg ref={ref} viewBox='0 0 512 512' onClick={onClick} width={size} height={size} className={className}>
      <path fill='#E2E5E7' d='M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z' />
      <path fill='#B0B7BD' d='M384,128h96L352,0v96C352,113.6,366.4,128,384,128z' />
      <polygon fill='#CAD1D8' points='480,224 384,128 480,128 ' />
      <path fill='#DE7BAF' d='M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16V416z' />
      <g>
        <path
          fill='#FFFFFF'
          d='M89,376.1v-72.7c0-4.6,3.3-7.9,9.1-7.9c4.5,0,7.8,3.3,7.8,7.9v27.9h41.7v-27.9c0-4.6,4.1-7.9,8.7-7.9 c4.5,0,7.9,3.3,7.9,7.9v72.7c0,4.5-3.5,7.9-7.9,7.9c-4.6,0-8.7-3.5-8.7-7.9v-28h-41.7v28c0,4.5-3.3,7.9-7.8,7.9 C92.3,384.1,89,380.6,89,376.1z'
        />
        <path
          fill='#FFFFFF'
          d='M216,311.5h-22.4c-11.1,0-11.1-16.4,0-16.4h60.5c11.4,0,11.4,16.4,0,16.4h-21.2v64.6c0,11.1-16.9,11.4-16.9,0 L216,311.5L216,311.5z'
        />
        <path
          fill='#FFFFFF'
          d='M304.9,328.5v47.3c0,5.6-4.6,8.8-9.2,8.8c-4.1,0-7.7-3.2-7.7-8.8v-72c0-6.7,5.6-8.8,7.7-8.8 c3.7,0,5.9,2.2,8,4.6l28.2,38l29.2-39.4c4.2-5.2,14.6-3.2,14.6,5.6v72c0,5.6-3.6,8.8-7.7,8.8c-4.6,0-8.2-3.2-8.2-8.8v-47.3 l-21.2,26.9c-4.6,5.6-10.4,5.6-14.6,0L304.9,328.5z'
        />
      </g>
      <path fill='#CAD1D8' d='M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z' />
    </svg>
  );
});

export default React.memo(Icon);
